import "./App.css";
import Vote from "./Vote";
import User from "./User";
import Board from "./Board";
import React from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";

export default function App() {
  return (
    <Router>
      <div className="App">
        <nav>
          <ul>
            <li>
              <NavLink to="/" end>2026</NavLink>
            </li>
            <li>
              <NavLink to="/vote">Vote</NavLink>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/vote" element={<Vote />} />

          {/* <Route path="/2021/:user" element={<User year={2021} />} />

          <Route path="/2022/:user" element={<User year={2022} />} />

          <Route path="/2023/:user" element={<User year={2023} />} />

          <Route path="/2024/:user" element={<User year={2024} />} /> */}

          <Route path="/2026/:user" element={<User year={2026} />} />
          {/* 
          <Route path="/2021" element={<Board year={2021} />} />

          <Route path="/2022" element={<Board year={2022} />} />

          <Route path="/2023" element={<Board year={2023} />} /> */}

          <Route path="/" element={<Board year={2026} />} />
        </Routes>
      </div>
    </Router>
  );
}
